import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';

class AdminProductionsCreateController extends Controller {
  @service api;
  @service store;
  @service router;

  @action
  cancel() {
    this.router.transitionTo('admin.productions');
  }

  @dropTask
  *save({ title, description, budget, amount, status, client_id, deadline }) {
    const response = yield this.api.post('companies/192/productions', {
      params: {
        include: 'client',
      },
      jsonData: {
        title,
        description,
        budget,
        amount,
        status,
        client_id,
        deadline: deadline?.toUTCString() ?? null,
      },
    });

    this.store.pushPayload(response);

    this.router.transitionTo(
      'admin.productions.view',
      this.store.peekRecord('production', response.data.id),
    );
  }
}

export default AdminProductionsCreateController;
